import { CATEGORIES, INGREDIENT, MANUFACTURERS, PRODUCTS_URL } from 'constants/Paths';
import { PRODUCT_INFO_CATEGORIES } from './SectionInformation.constant';
import { IngredientProps } from './ui/Ingredient';
import { getLinkCDNImage } from 'utils/ImageUtils';

export const isEmptyContent = (content: string): boolean => {
  const div = document.createElement('div');
  div.innerHTML = content;
  
  return div.textContent?.trim() === '' && !div.querySelector('img')
};

const filterEmptyHtml = (content: string) => (isEmptyContent(content) ? '' : content);

/**
 * Replace all <img> src attributes in the HTML string using getLinkCDNImage.
 * @param html The HTML string to process.
 * @returns The HTML string with updated img src attributes.
 */
export function replaceImgSrc(html: string): string {
  if (!html) return html;
  return html.replace(/<img([^>]+?)src=["']([^"']+)["']/gi, (match, before, src) => {
    return `<img${before}src="${getLinkCDNImage(src, "large")}"`;
  });
}

export const adaptProductInformation = (product: any) => {
  try {
    const contraindication = filterEmptyHtml(product.description.contraindication);
    const description = filterEmptyHtml(replaceImgSrc(product.description.description));
    const dosage = filterEmptyHtml(product.description.dosage);
    const drugInteraction = filterEmptyHtml(product.description.drugInteraction);
    const drugOverdose = filterEmptyHtml(product.description.drugOverdose);
    const indication = filterEmptyHtml(product.description.indication);
    const storage = filterEmptyHtml(product.description.storage);

    const registrationNumber = product.registrationNumber;

    const ingredients: IngredientProps['value'] = product.ingredients?.length
      ? product.ingredients.map((ingredient: any) => ({
          quantity: ingredient.volume,
          name: ingredient.name,
          url: `${INGREDIENT}/${ingredient.slug}`,
        }))
      : undefined;

    const expiredDate = product.expiredDate ? product.expiredDate.split('-').reverse().join('-') : '';
    const categories:
      | {
          href: string;
          label: string;
        }[]
      | undefined = !!product.categories?.length
      ? product.categories.map((item: {
          slug: string;
          name: string;
      }) => ({
          href: `${CATEGORIES}/${item?.slug}`,
          label: item.name,
        }))
      : undefined;
    const manufacturer = product.manufacturer
      ? {
          label: product.manufacturer?.name,
          href: `${MANUFACTURERS}/${product.manufacturer?.slug}`,
        }
      : undefined;
    const country = product?.originName;
    const documents:
      | {
          href: string;
          label: string;
        }[]
      | undefined = !!product.documents?.length
      ? product.documents.map((item: any) => ({
          href: item.link,
          label: item.fileName,
        }))
      : undefined;

    const brand: {
      label: string;
      href: string;
    } | undefined = product.brandInfo ?
      {
        label: product.brandInfo.name,
        href: `${PRODUCTS_URL}?brand=${product.brandInfo.slug}`,
      }
      : undefined;

    const adaptedCategories = {
      contraindication,
      description,
      dosage,
      drugInteraction,
      drugOverdose,
      indication,
      storage,
      ingredients,
    };

    const infoCategories = PRODUCT_INFO_CATEGORIES;
    // .filter((item) => {
    //   if (item.id === 'description') {
    //     return adaptedCategories[item.id] || !!categories || !!expiredDate || !!manufacturer || !!country || !!documents;
    //   } else {
    //     return !!adaptedCategories[item.id];
    //   }
    // });

    const isEmpty = infoCategories.length === 0;

    return { ...adaptedCategories, infoCategories, categories, expiredDate, manufacturer, country, documents, isEmpty, registrationNumber, brand };
  } catch (e) {
    return {
      isEmpty: true,
      infoCategories: [],
      contraindication: '',
      description: '',
      dosage: '',
      drugInteraction: '',
      drugOverdose: '',
      indication: '',
      storage: '',
      ingredients: undefined,
      categories: undefined,
      expiredDate: '',
      manufacturer: undefined,
      country: '',
      documents: undefined,
      registrationNumber: '',
      brand: undefined,
    };
  }
};
